import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBoxStringValue } from '../../models/selectbox';
import { thongKeBangChamCongTheoDonVi } from '../../services/chamcong';

const DonViChamCongSelectBox = ({ value, searchData, disabled, onChange }: { value?: string, searchData: any,  disabled?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBoxStringValue>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await thongKeBangChamCongTheoDonVi(searchData);
            setData(rs);
        } catch (error: any) {
        };
    }
    useEffect(() => {
        setData([]);
        layDuLieu();
    }, [searchData]);
    return (
        <Select
            style={{ width: '100%' }}
            showSearch
            allowClear
            notFoundContent="Không có dữ liệu"
            placeholder="--Chọn bảng chấm công--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            options={data}
            value={value}
            onChange={(e: string | undefined) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
            disabled={disabled}
        />
    );
};

export default DonViChamCongSelectBox;
